export default "__VITE_ASSET__BJX0tdaJ__"